<template>
    <svg
        :class="{
            'icon__youtube': hoverState == true
        }"
        width="22"
        height="16"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="youtubeIconTitle"
    >
        <title id="youtubeIconTitle">YouTube logo</title>
        <path
            d="M21.538 2.84A2.699 2.699 0 0 0 19.576.95C17.861.5 10.992.5 10.992.5S4.116.5 2.4.95A2.705 2.705 0 0 0 .462 2.84 27.077 27.077 0 0 0 .001 8c-.012 1.73.143 3.458.461 5.16A2.705 2.705 0 0 0 2.4 15.05c1.716.45 8.592.45 8.592.45s6.87 0 8.584-.45a2.699 2.699 0 0 0 1.962-1.89c.318-1.702.473-3.43.461-5.16a27.077 27.077 0 0 0-.461-5.16zM8.792 11.217V4.783L14.5 8l-5.708 3.217z"
            fill="#F2F2F2"
            fill-rule="nonzero"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconYouTube',
    props: {
        hoverState: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__youtube {
    path {
        transition: all 0.3s ease;
    }
    &:hover {
        path {
            fill: $primary;
        }
    }
}
</style>
